import Marquee from "react-fast-marquee";

const items = ["Garanzia economica 10 anni", "Carico immediato", "Trasparenza totale", "8 studi in Italia", "€4.900 ad arcata", "Direttori sanitari indipendenti"];

export const EditorialMarquee = () => (
  <div className="bg-[#DDEBF2] py-6 md:py-8 border-y border-border" data-testid="editorial-marquee">
    <Marquee speed={35} gradient={false} autoFill>
      {items.map((t, i) => (
        <span key={`${t}-${i}`} className="flex items-center">
          <span className="font-serif-display italic text-2xl md:text-4xl text-[#385244] mx-6 md:mx-10">{t}</span>
          <span className="text-[#C98E6E] text-2xl md:text-3xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
